import styled from 'styled-components'

export const FeedbackPage = styled.div`
  height: 100%;
  padding: 1rem;
`

export const FeedbackPageContent = styled.div`
  min-height: calc(100% - 48px);
  text-align: center;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 64px;
    heigth: 64px;
  }
`
